module.exports = __webpack_public_path__ + "img/slip.535d36cd.png";